import { MessageEventItemTypes } from '../interfaces';
import { messageEventTransformFlow } from './message-events.transform';
import { participantEventTransformFlow } from './participant-events.transform';
import {
  addAsyncWaitMessage,
  cacheComputedEvents,
  ConversationDTOStatus,
} from './utils';
import { waitEventTransformFlow } from './wait-events.transform';
import moment from 'moment';
import { transformDMAutoReply } from './dm-auto-reply.tranform';

export const labelFirstOfDay = (
  messageEvents: MessageEventItemTypes[] = [],
): MessageEventItemTypes[] => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  let firstEventOfDay: boolean;
  let firstEventOfDayDate: Date;
  return messageEvents.reduce<MessageEventItemTypes[]>((ret, cur, i) => {
    if (moment(cur.created).isSame(firstEventOfDayDate, 'd') && i !== 0) {
      firstEventOfDay = false;
    } else {
      firstEventOfDay = true;
      firstEventOfDayDate = cur.created;
    }

    ret.push({
      ...cur,
      firstEventOfDay,
    });

    return ret;
  }, []);
};

export const transformEvents = (
  conversation: ConversationDTOStatus,
  personalGuideEligible: boolean,
  isEvernorthEnabled: boolean,
): MessageEventItemTypes[] => {
  let events = [
    ...messageEventTransformFlow(conversation),
    ...waitEventTransformFlow(
      conversation,
      personalGuideEligible,
      isEvernorthEnabled,
    ),
    ...participantEventTransformFlow(conversation),
    ...transformDMAutoReply(conversation),
  ].sort((a, b) => {
    if (a.created > b.created) {
      return 1;
    }

    if (a.created < b.created) {
      return -1;
    }

    return 0;
  });

  if (
    conversation.type === 'async' &&
    (conversation.state === 'opening' ||
      (conversation.state === 'opened' &&
        conversation.status === 'AWAITING_AGENT'))
  ) {
    events = addAsyncWaitMessage(
      events,
      conversation.context.tags,
      conversation.created,
    );
  }

  return labelFirstOfDay(events);
};

export const getCachedTransformedEvents = cacheComputedEvents(transformEvents);
